// General-purpose Google selection is shared by web, SiteCall and RAG.
// Dedicated embeddings, speech and third-party voice models remain separate.
import { DEFAULT_GEMINI_MODEL } from "@atriam/contracts/ai";

export const DEFAULT_LLM_MODEL = DEFAULT_GEMINI_MODEL;
export type DefaultLlmModel = typeof DEFAULT_LLM_MODEL;

export const LATEST_GPT_MINI = "gpt-5.4-mini" as const;
export type LatestGptMini = typeof LATEST_GPT_MINI;
